import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { mobilitySurveyBikeReasons } from '../../models';
import StatsCard from './stats-card';
export const transportHabitsBikeReasonsMap = {
  positiveImpactOnHealth: {
    labelKey: 'commons.transport_habits.bike_reasons.positive_impact_on_health',
    shortKey: 'commons.transport_habits.bike_reasons.positive_impact_on_health_short'
  },
  practicalOrQuick: {
    labelKey: 'commons.transport_habits.bike_reasons.practical_or_quick',
    shortKey: 'commons.transport_habits.bike_reasons.practical_or_quick_short'
  },
  saveMoney: {
    labelKey: 'commons.transport_habits.bike_reasons.save_money',
    shortKey: 'commons.transport_habits.bike_reasons.save_money_short'
  },
  fmd: {
    labelKey: 'commons.transport_habits.bike_reasons.fmd',
    shortKey: 'commons.transport_habits.bike_reasons.fmd_short'
  },
  positiveImpactOnEnvironment: {
    labelKey: 'commons.transport_habits.bike_reasons.positive_impact_on_environment',
    shortKey: 'commons.transport_habits.bike_reasons.positive_impact_on_environment_short'
  },
  cyclingCommunity: {
    labelKey: 'commons.transport_habits.bike_reasons.cycling_community',
    shortKey: 'commons.transport_habits.bike_reasons.cycling_community_short'
  },
  pleasureAndFreedom: {
    labelKey: 'commons.transport_habits.bike_reasons.pleasure_and_freedom',
    shortKey: 'commons.transport_habits.bike_reasons.pleasure_and_freedom_short'
  }
};
export function TransportHabitsBenefits({
  progressBarWidth,
  stats
}) {
  const [items, setItems] = useState();
  const {
    t
  } = useTranslation();
  useEffect(() => {
    setItems(stats ? mobilitySurveyBikeReasons.map(key => ({
      key,
      label: t(transportHabitsBikeReasonsMap[key].labelKey),
      count: stats.benefits[key] || 0
    })).sort((a, b) => b.count - a.count) : undefined);
  }, [stats]);
  return /*#__PURE__*/React.createElement(StatsCard, {
    items: items,
    progressBarColor: "#2ac682",
    progressBarWidth: progressBarWidth,
    respondantsCount: stats?.benefitsRespondantsCount,
    title: t('commons.transport_habits.bike_reasons.title')
  });
}